module.exports = __webpack_public_path__ + "img/star-map_backgrounds-watercolor_white.79277dd.webp";